const closedCaption = (state = [], action) =>
{
	switch (action.type)
	{
		case 'ADD_CLOSED_CAPTION':
		{
			const { sttId, sessionId, isFinal, offset, text, peerId } = action.payload;
			const message = { sttId, sessionId, offset, isFinal, text, peerId };

			let length = 0;

			for (const ml of state)
			{
				length += ml.text.length;
			}

			if (length + text.length > 300 || state.length > 2)
				return [ message ];
			else
			{
				const isPreviousMessage = state.some((m) => m.sttId === sttId);

				if (isPreviousMessage)
				{
					return state.map((m) => (m.sttId === sttId ? message : m));
				}
				else
				{
					return [ ...state, message ];
				}
			}

		}
		case 'CLEAR_CLOSED_CAPTION':
		{
			return [];
		}

		default:
			return state;
	}
};

export default closedCaption;
